import { useMutation } from "@apollo/react-hooks";
import { useAsyncCallback } from 'react-use-async-callback';
import gql from "graphql-tag";
import { AsyncActionStatus } from '../../../shared/abstractStore';
import { QuestionTagLinkCreateInput } from '../generated/globalTypes';
import { createQuestionTagLinkMutation, createQuestionTagLinkMutationVariables } from '../generated/createQuestionTagLinkMutation';
import { questionTagLinkFieldsFragment } from '../models/QuestionTagLink';

/**
 * Get a callback to create a QuestionTagLink in the store.
 */
export function useCreateQuestionTagLinkCallback(): [(model: QuestionTagLinkCreateInput) => Promise<void>, AsyncActionStatus] {
    const [mutationAction, { error }] = useMutation<createQuestionTagLinkMutation, createQuestionTagLinkMutationVariables>(
        gql`
            mutation createQuestionTagLinkMutation ($model: QuestionTagLinkCreateInput!) {
                createQuestionTagLink(model: $model) {
                    ...questionTagLinkFields
                }
            }

            ${questionTagLinkFieldsFragment}
        `
    );

    // Wrap the mutation in a standard callback.
    const [action, { isExecuting, errors: actionErrors }] = useAsyncCallback(async (model: QuestionTagLinkCreateInput) => {
        const result = await mutationAction({ variables: { model: model } });
        if (result.errors && result.errors.length) {
            throw result.errors;
        }
    }, [mutationAction]);

    return [action, { isExecuting: isExecuting, errors: error ? error.message : actionErrors }];
}
